<div class="w-full">
  <!-- Search Bar -->
  <div class="glass-card p-4 rounded-2xl mb-6">
    <div class="flex flex-col md:flex-row gap-4 items-start md:items-center">
      <div class="relative flex-1 max-w-md">
        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <span class="material-icons text-xl text-text-muted">search</span>
        </div>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Suche nach Titel oder Beschreibung..."
          class="search-input w-full pl-12 pr-10 py-3 rounded-xl bg-white/8 border border-white/12 text-text-primary placeholder-text-muted focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all"
        />
        @if (searchTerm) {
          <button
            type="button"
            class="absolute inset-y-0 right-0 pr-4 flex items-center text-text-muted hover:text-text-primary transition-colors"
            (click)="clearSearch()"
          >
            <span class="material-icons text-xl">close</span>
          </button>
        }
      </div>

      <div class="md:ml-auto">
        <button type="button" class="btn-primary flex items-center gap-2" (click)="openCreateModal()">
          <span class="material-icons text-xl">add</span>
          Textbaustein hinzufügen
        </button>
      </div>
    </div>
  </div>

  <!-- Text Blocks Table -->
  <div class="glass-card rounded-2xl overflow-hidden">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="flex items-center justify-center py-20">
        <div class="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent"></div>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="border-b border-white/10">
              <th class="table-header" (click)="onSort('title')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Titel
                  @if (sortField === 'title') {
                    <span class="material-icons text-sm">{{ sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
                  }
                </div>
              </th>
              <th class="table-header" (click)="onSort('description')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Beschreibung
                  @if (sortField === 'description') {
                    <span class="material-icons text-sm">{{ sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
                  }
                </div>
              </th>
              <th class="table-header" (click)="onSort('type')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Typ
                  @if (sortField === 'type') {
                    <span class="material-icons text-sm">{{ sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
                  }
                </div>
              </th>
              <th class="table-header" (click)="onSort('createdAt')">
                <div class="flex items-center gap-1 cursor-pointer hover:text-text-primary transition-colors">
                  Erstellt am
                  @if (sortField === 'createdAt') {
                    <span class="material-icons text-sm">{{ sortDirection === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
                  }
                </div>
              </th>
              <th class="table-header">
                <span class="sr-only">Aktionen</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @if (textBlocks.length === 0) {
              <tr>
                <td colspan="5" class="px-6 py-12 text-center text-text-muted">Es wurden noch keine Textblöcke angelegt.</td>
              </tr>
            } @else {
              @for (textBlock of textBlocks; track textBlock) {
                <tr class="table-row border-b border-white/6 transition-colors hover:bg-white/4">
                  <td class="table-cell">
                    <span
                      [title]="textBlock.title"
                      class="font-medium text-text-primary whitespace-nowrap text-ellipsis max-w-50 overflow-hidden block"
                      >{{ textBlock.title }}</span
                    >
                  </td>
                  <td class="table-cell">
                    <span class="whitespace-nowrap text-ellipsis max-w-100 overflow-hidden block" [title]="textBlock.description">{{
                      textBlock.description
                    }}</span>
                  </td>
                  <td class="table-cell">
                    @if (textBlock.type) {
                      <span class="text-xs px-2 py-1 rounded" [ngClass]="typeBadgeClass(textBlock.type)" [title]="typeLabel(textBlock.type)">{{ textBlock.type }}</span>
                    } @else {
                      <span class="text-xs text-text-muted">—</span>
                    }
                  </td>
                  <td class="table-cell">
                    <span class="text-xs bg-white/8 px-2 py-1 rounded">{{ textBlock.createdAt | date: 'dd.MM.yyyy' }}</span>
                  </td>
                  <td class="table-cell">
                    <div class="flex items-center gap-2">
                      <button
                        type="button"
                        class="p-2 cursor-pointer rounded-lg text-text-muted hover:text-primary hover:bg-white/10 transition-all flex items-center justify-center"
                        (click)="openEditModal(textBlock)"
                        title="Bearbeiten"
                      >
                        <span class="material-icons text-lg">edit</span>
                      </button>
                      <button
                        type="button"
                        class="p-2 cursor-pointer rounded-lg text-text-muted hover:text-red-400 hover:bg-red-500/10 transition-all flex items-center justify-center"
                        (click)="openDeleteModal(textBlock)"
                        title="Löschen"
                      >
                        <span class="material-icons text-lg">delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      @if (totalItems > 0) {
        <div class="px-6 py-4 border-t border-white/10">
          <app-pagination
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            (pageChange)="onPageChange($event)"
          ></app-pagination>
        </div>
      }
    }
  </div>
</div>
